var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -150 550 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;}.cls-2,.cls-4{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#000;stroke-width:30px;}.cls-3{opacity:0.5;}.cls-4{stroke:#fff;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M548.14,193.67c0-74.74-60.8-135.54-135.51-135.54A135.69,135.69,0,0,0,289.17,137.8,135.65,135.65,0,0,0,165.75,58.13C91,58.13,30.21,118.93,30.21,193.67A135.87,135.87,0,0,0,78.19,297L284.9,502.34a6.44,6.44,0,0,0,4.6,1.91,6.51,6.51,0,0,0,4.64-1.91l214.39-213,0,0a134.8,134.8,0,0,0,39.63-95.64Z",
    transform: "translate(-15.21 -43.13)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M548.14,193.67c0-74.74-60.8-135.54-135.51-135.54A135.69,135.69,0,0,0,289.17,137.8,135.65,135.65,0,0,0,165.75,58.13C91,58.13,30.21,118.93,30.21,193.67A135.87,135.87,0,0,0,78.19,297L284.9,502.34a6.44,6.44,0,0,0,4.6,1.91,6.51,6.51,0,0,0,4.64-1.91l214.39-213,0,0a134.8,134.8,0,0,0,39.63-95.64Z",
    transform: "translate(-15.21 -43.13)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.01433234aad445dbe3d648f5a071d86d.svg";
export { ForwardRef as ReactComponent };